export default [
  { text: "chat.archive_status.ARCHIVED", value: true },
  { text: "chat.archive_status.NOT_ARCHIVED", value: false },
  { text: "chat.archive_status.ALL", value: null },
];
